import MatchResourcePage from './MatchResourcePage';
import MatchResourcePageEdit from './MatchResourcePageEdit';

export default {
    list: MatchResourcePage,
    edit: MatchResourcePageEdit,
}